import PropTypes from 'prop-types'
import React from 'react'

import Avatar from 'shared-web/src/components/Avatar'
import SendFromEdit from 'components/shared/SendFromEdit'

import styles from './style.styl'

function UserSelectionSection({ user, onSelect, noUserText, enableClear=true }) {
  return (
    <div className={styles.UserSelectionSection}>
      <Avatar user={user}/>
      <div className="dsg-Regular">
        <div className="dsg-Body">
          {user ? user.name || user.email : noUserText}
        </div>
        <SendFromEdit
          user={user}
          onSenderSelect={onSelect}
          enableClear={enableClear}
        />
      </div>
    </div>
  )
}
UserSelectionSection.propTypes = {
  onSelect: PropTypes.func.isRequired,
  user: PropTypes.object,
  noUserText: PropTypes.string
}

UserSelectionSection.defaultProps = {
  noUserText: 'No user selected'
}
export default UserSelectionSection



// WEBPACK FOOTER //
// ./src/scripts/components/UserSelectionSection/index.js